<template>
    <div class="swiper-news-wrapper">
        <swiper ref="mySwiper" :options="swiperOptions">
            <swiper-slide @click.native="gotodetail(item.id)" class="swiper-item" v-for="(item, index) in list"
                :key="index">
                <SmallNews :data="item"></SmallNews>
            </swiper-slide>
        </swiper>
    </div>
</template>
<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import SmallNews from '@/components/SmallNews.vue'
import 'swiper/css/swiper.css'
export default {
    components: {
        Swiper,
        SwiperSlide,
        SmallNews
    },
    data() {
        return {
            showSwiper: false,
            swiperOptions: {
                autoplay: {
                    delay: 500000,
                    stopOnLastSlide: false,
                    disableOnInteraction: false
                },
                loop: true,
            },
            list: []
        }
    },
    created() {
        this.getList()
    },
    methods: {
        gotodetail(id) {
            this.$router.push('/newsDetail?id=' + id);
        },
        async getList() {
            let fdata = { do: 'json', sjk: 'article', searchkey: 'iftuijian', searchvalue: '1', limit: 3 }
            let res = await this.$api.funk(fdata)
            this.list = res
            let timer = setTimeout(() => {
                this.showSwiper = true
                clearTimeout(timer)
            }, 500)
        }
    }
}
</script>
<style lang="scss" scoped>
.swiper-news-wrapper {
    display: none;
}

.swiper-item {
    z-index: 100;
}

@media (max-width: 750px) {
    .swiper-news-wrapper {
        display: block;
        padding: 0 0.4rem;
    }
}
</style>